var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"counter-box"},[_vm._t("default"),_c('p',{staticClass:"counter-number"},[_vm._v(_vm._s(_vm.counter))]),_c('p',{staticClass:"counter-caption"},[_vm._v(_vm._s(_vm.caption))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }